module.exports = __webpack_public_path__ + "media/images/v3/thumb1-e0bb72c04a71582b3ef2bb48a0ef77d1.png";